// extracted by mini-css-extract-plugin
export default {"contactCell":"EwCtKneywZgVSsqb3GAt"};